"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _mqBreakpoints = _interopRequireDefault(require("@ruter-ds/rds-tokens/dist/json/mq-breakpoints.json"));

var _utils = require("../../utils");

require("./Col.scss");

var _excluded = ["first", "last", "alignSelf", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var breakPoints = Object.keys(_mqBreakpoints.default);
var columnSizes = breakPoints.map(function (size) {
  return size.toLowerCase();
});
var propTypes = {
  /** Choose how many columns the element spans starting at 0px  */
  all: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element spans from `xxs` breakpoint */
  xxs: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element spans from `xs` breakpoint */
  xs: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element spans from `s` breakpoint */
  s: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element spans from `m` breakpoint */
  m: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element spans from `l` breakpoint */
  l: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element spans from `xl` breakpoint */
  xl: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element spans from `xxl` breakpoint */
  xxl: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element should offset from the left starting at 0px  */
  allOffset: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element should offset from the left from `xxs` breakpoint */
  xxsOffset: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element should offset from the left from `xs` breakpoint */
  xsOffset: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element should offset from the left from `s` breakpoint */
  sOffset: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element should offset from the left from `m` breakpoint */
  mOffset: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element should offset from the left from `l` breakpoint */
  lOffset: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element should offset from the left from `xl` breakpoint */
  xlOffset: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Choose how many columns the element should offset from the left from `xxl` breakpoint */
  xxlOffset: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Hide element on all breakpoints starting at 0px  */
  allHidden: _propTypes.bool,

  /** Hide element from `xxs` breakpoint  */
  xxsHidden: _propTypes.bool,

  /** Hide element from `xs` breakpoint  */
  xsHidden: _propTypes.bool,

  /** Hide element from `s` breakpoint  */
  sHidden: _propTypes.bool,

  /** Hide element from `m` breakpoint  */
  mHidden: _propTypes.bool,

  /** Hide element from `l` breakpoint  */
  lHidden: _propTypes.bool,

  /** Hide element from `xl` breakpoint  */
  xlHidden: _propTypes.bool,

  /** Hide element from `xxl` breakpoint  */
  xxlHidden: _propTypes.bool,

  /** Change order of element to visually appear first */
  first: _propTypes.bool,

  /** Change order of element to visually appear last */
  last: _propTypes.bool,
  alignSelf: (0, _propTypes.oneOf)(['start', 'center', 'end']),

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {};
/** Columns are basically "buckets" for content. A component, widget, module or
 * anything else.
 * @visibleName Grid Col
 * */

var Col = /*#__PURE__*/function (_React$Component) {
  _inherits(Col, _React$Component);

  var _super = _createSuper(Col);

  function Col() {
    _classCallCheck(this, Col);

    return _super.apply(this, arguments);
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          first = _this$props.first,
          last = _this$props.last,
          alignSelf = _this$props.alignSelf,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, _excluded);

      var _splitBsProps = (0, _utils.splitBsProps)(props),
          _splitBsProps2 = _slicedToArray(_splitBsProps, 2),
          bsProps = _splitBsProps2[0],
          elementProps = _splitBsProps2[1];

      var classes = [];
      columnSizes.forEach(function (size) {
        function popProp(propSuffix, modifier) {
          var propName = "".concat(size).concat(propSuffix);
          var propValue = elementProps[propName];

          if (propValue != null) {
            classes.push((0, _utils.prefix)(bsProps, "".concat(modifier).concat(propValue, "@").concat(size)));
          }

          delete elementProps[propName];
        }

        popProp('', '');
        popProp('Offset', 'offset-');
        var hiddenPropName = "".concat(size, "Hidden");

        if (elementProps[hiddenPropName]) {
          classes.push("rds-hidden@".concat(size));
        }

        delete elementProps[hiddenPropName];
      });
      var componentClassNames = (0, _classnames.default)('rds-col', {
        'rds-col-first': first,
        'rds-col-last': last,
        'rds-as-start': alignSelf === 'start',
        'rds-as-center': alignSelf === 'center',
        'rds-as-end': alignSelf === 'end'
      }, classes, className);
      return /*#__PURE__*/_react.default.createElement("div", _extends({}, elementProps, {
        className: componentClassNames
      }));
    }
  }]);

  return Col;
}(_react.default.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;

var _default = (0, _utils.bsClass)('rds-col', Col);

exports.default = _default;